import { Highlight } from 'legacy/lut/components/widgets/public/Highlight'

interface IGeneralReportHighlightProps {
  word?: string
  children: string | string[]
  className?: string
}

export const TrainingCentreHighlight = ({
  word,
  children,
  className,
}: IGeneralReportHighlightProps) => {
  return (
    <Highlight words={word && word.length >= 3 ? [word] : []} className={className}>
      {children}
    </Highlight>
  )
}
